import jsPDF from "jspdf";
import { formatNumberToDollar } from "./util";
import { format } from "date-fns";

const generateFormData = (invoiceData, pdfBlob) => {
  const formData = new FormData();

  formData.append(
    "files",
    pdfBlob,
    `invoice-${invoiceData.invoice_number}.pdf`
  );

  return formData;
};

export const generatePDF = (invoiceData) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // Logo dimensions and styling - centered position
  const imgWidth = 15; // reduced from 30
  const imgHeight = 15; // reduced from 30
  const imgX = (pageWidth - imgWidth) / 2;
  const imgY = 15;

  // Add logo with background
  doc.setFillColor(128, 130, 133);
  doc.rect(imgX - 2, imgY - 2, imgWidth + 4, imgHeight + 4, "F");

  const imgData =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAABdCAYAAAAiw23qAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAVeSURBVHgB7d3vcdtGEAXwx4y+Wx0EqSBMBUEHkioIXEGkCkRXEKcC0hVYqYB0BWYqIF2B5QrOu8JBljkkgFsccKDwfjM39IgUAR2f8e+OC4CIaKpmoME4567l4R/El89msy9tXyzr8bc83LZ46aNvauvbF1nWBpFcIDHpjEt5uEQcj9I5jxgv/TszpGdZj7z6h3xm+rCRtpL238j7vJ78MbmLZ9mwrKWL5y8Ekt8pXD9+DVyPexfXUloGg19A1F0hbWcJIgNIMRXSPksIF21/gQEc1vkeK7Wnx5f3EsLPbbaGDOCwphDAylzauimEDCD1KUO5S56fegEDSH3TXfL6VAgZQBpCFcLs8AkGkIZShfCnQYfkIyETs5e2qHleP5w2Q2Rd/Y9yFKNJhnKd5ogjQzkU+RZj4SY0EtKiLzJnEzQSYlivS2lXLl7/5dV7cxdMjXSsV5qO+eqW6ze023rWua/+wQBSEAnh3gfxDnZ5tRVkAMlEQvge3Y7lnraCDCCZSQhXsIdQt4KXDCB14kP4AJsrBpBisB4PzhlA6kxPTFDOkA41H8OFaJ0hskEcWzQva484pjSzpQ3dDecIk4HGw430QnTLdb92BtwFUyxNe5+jGECKJYMBA0hJMYAUy58wYAAplhzh9gwgdebKmc45wj1Guw7oynoj14jjTi5ubk8sJ8eL6TwdrWQ5H04sRydifkQcOp3pBq+X9fN4iHkhWmfN5ojjTc1zWcTlbGqeu4y4nD1eKfmPqjO4C9hsuQsmMwlfAXu1r61OcmUAycRv+ZawezrE4peSKIg/4dCtXpfj/WpWNQNI7fiTvyuUx3td6zk+zx9kACfIh6npwnFVOFRPLjPEKyKqx37P8wcZwGnS8C2Qxk9T+HkSQkO6Pry+ywDSUBZ62eXwh9wF0xBuJXz/HnuCAaQ+7aXdnBpWVdwFU58e6sKnGEDq061c8vnoDkqyvcQAUt90xGR9KoQMIA1BL2Yf3RIygDSUHEdmzjCANKTCz6J5diE/aJrN+vIujBtfhoHOmHyG7+ThXZvXurK6vTYdvivQ3b2850OVo5l+Oz3gl4uGKexvEMe3U3dgHGo5flnRKg60uZ2qn+q0Q7gs5HatVn79tDTxAt2squlYcGGi10WmH9yZlObw67lz3TydkPAYkIL53ecf0j7ATr/ExgCSjS9cXsBe2ezpZIQBpK70WM5Sqk5v/ZAzgNSJ3x2/h83vDCDFoFOtLFvBPHQ6lp795KC+ZDhDejwoudAvGhUIE1yidwGi4ywFKjPugikW04VwBpBiMRVtZwApKQaQkmIAKSkGkJJiACkpBpCSYgApKQaQkmIAKSkGkJK6mAkQJcItICXFAFJSDCAlxQBSUgwgJRU0Jd+VpRn0ZiVz/yOdhKhTsT+xZkw8vmqA1tV7WfFA+3iDKfKlGNYNpRaWPqBk5Pt5WdPHO2kLV1NxNBX9spozaPPGWlLra8v32zGENv4DPNt+dn0EUJ6/duG+jq1zxk76a+7C7cbUzy52AF23CkhrUCuvpZ+dMYB1Z8FauDKDja5MDmqjwIT7uS6AObppqrxKpa41F8+6n48G0JVlWTN0MwfVYj+f3gLGOM3X8luDVu48Q5Pv5z4DSNToVAD3iGCIwtlnzlTO4tA59/PRAPobzHXtnA2oyR4T7+e6s+AVulmBavlbRKzQzQqvkb9A2nZo6JDlXheT5Oy3ZhhVP7vYF6L97JZWd9M54gbUiu/nO9hYf68Pe/RBQnofEGjdYvJmNgaB/ezG1s/OuCVv9Y04eZ3OTdM7HWY1L9tIe8t5gXbSzwWah0D1BPFW+vkTRsSVEyOWCPQdLxeo6uINIIUAAAAASUVORK5CYII=";
  doc.addImage(imgData, "PNG", imgX, imgY, imgWidth, imgHeight);

  // Document Title with better positioning and styling
  doc.setFontSize(28);
  doc.setFont("helvetica", "bold");
  doc.text("PAYMENT INVOICE", pageWidth / 2, imgY + imgHeight + 20, {
    align: "center",
  });

  // Add divider line under title
  doc.setDrawColor(128, 130, 133);
  doc.setLineWidth(0.5);
  doc.line(20, imgY + imgHeight + 25, pageWidth - 20, imgY + imgHeight + 25);

  // Increase starting Y position for invoice details to avoid overlap
  const detailsStartY = imgY + imgHeight + 40;

  // Invoice details with improved styling and spacing
  doc.setFontSize(11);
  doc.setFont("helvetica", "normal");

  const leftDetails = [
    {
      label: "Vendor:",
      value: String(
        invoiceData?.user_details?.first_name +
          " " +
          invoiceData?.user_details?.last_name || "NA"
      ),
    },
    {
      label: "Invoice Number:",
      value: String(invoiceData?.invoice_number || "NA"),
    },
    {
      label: "Date:",
      value: String(format(new Date(), "MMMM d, yyyy")) || "NA",
    },
    {
      label: "Shipment Date:",
      value: invoiceData?.shipment_date
        ? format(new Date(invoiceData.shipment_date), "MMMM d, yyyy")
        : "NA",
    },
  ];

  leftDetails.forEach((detail, index) => {
    const yPosition = detailsStartY + index * 10; // Increased spacing
    doc.setFont("helvetica", "bold");
    doc.text(detail.label, 20, yPosition);
    doc.setFont("helvetica", "normal");
    doc.text(detail.value, 70, yPosition);
  });

  // Right column with labels in bold
  const rightDetails = [
    {
      label: "Prepared for:",
      value: String(
        invoiceData?.user_details?.first_name +
          " " +
          invoiceData?.user_details?.last_name || "NA"
      ),
    },
    {
      label: "Shipment ID:",
      value: String(invoiceData?.id || "NA"),
    },
    {
      label: "Trusted Member:",
      value: String(invoiceData?.user_details?.is_trusted ? "Yes" : "No"),
    },
  ];

  rightDetails.forEach((detail, index) => {
    const yPosition = detailsStartY + index * 10; // Increased spacing
    doc.setFont("helvetica", "bold");
    doc.text(detail.label, pageWidth - 100, yPosition);
    doc.setFont("helvetica", "normal");
    doc.text(detail.value, pageWidth - 40, yPosition);
  });

  // Increase starting Y position for table to avoid overlap with details
  const tableStartY = detailsStartY + 40;

  // Enhanced table styling
  const tableColumn = ["Description", "QTY", "Unit Price", "Total"];
  const tableRows =
    invoiceData?.shipment_boxes?.map((item) => [
      String(`${item?.order_id}, ${item?.name}` || "NA"),
      String(item?.quantity || 0),
      formatNumberToDollar(Number(item?.cashout_price || 0)),
      formatNumberToDollar(Number(item?.cashout_price * item?.quantity || 0)),
    ]) || [];

  doc.autoTable({
    head: [tableColumn],
    body: tableRows,
    startY: tableStartY,
    theme: "grid",
    styles: {
      fontSize: 10,
      cellPadding: 5,
      lineColor: [220, 220, 220],
      lineWidth: 0.5,
    },
    headStyles: {
      fillColor: [60, 60, 60],
      textColor: [255, 255, 255],
      fontStyle: "bold",
      halign: "center",
    },
    bodyStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
    },
    alternateRowStyles: {
      fillColor: [245, 245, 245],
    },
    columnStyles: {
      0: { cellWidth: "auto" },
      1: { cellWidth: 30, halign: "center" },
      2: { cellWidth: 40, halign: "right" },
      3: { cellWidth: 40, halign: "right" },
    },
    pageBreak: "auto",
    margin: { top: 30 },
    didDrawPage: (data) => {
      // Header on each page
      if (data.pageCount > 1) {
        doc.setFontSize(10);
        doc.setTextColor(128, 128, 128);
        doc.text(`Invoice #${invoiceData.invoice_number}`, 20, 10);
      }
      doc.setFontSize(8);
      doc.setTextColor(128, 128, 128);
      doc.text(
        `Page ${data.pageCount}`,
        data.settings.margin.left,
        pageHeight - 10
      );
    },
  });

  // Total section with enhanced styling
  const finalY = doc.previousAutoTable.finalY || 150;
  doc.setDrawColor(128, 130, 133);
  doc.setLineWidth(0.5);
  doc.line(pageWidth - 100, finalY + 10, pageWidth - 20, finalY + 10);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);

  const total = invoiceData?.shipment_boxes?.reduce(
    (sum, item) => sum + (Number(item?.cashout_price * item?.quantity) || 0),
    0
  );

  doc.text(
    `Total Amount: ${formatNumberToDollar(total)}`,
    pageWidth - 20,
    finalY + 20,
    {
      align: "right",
    }
  );

  // Footer with contact info
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(128, 128, 128);
  doc.text(
    "Please email support@rs-chain.com for questions.",
    20,
    pageHeight - 20
  );

  // Invoice details and table setup (omitted for brevity but remains the same)

  // Save the PDF to a Blob
  const pdfBlob = doc.output("blob");

  // Generate FormData
  return generateFormData(invoiceData, pdfBlob);
};
